import React from "react"
import {
  Box, Flex, Input, Text,
} from "@chakra-ui/react"
import CopyToClipboard from "components/elements/CopyToClipboard"

type Props = {
  label: string
  value: string
  helperText?: string
}

const CopyableLink = ({ label, value, helperText }: Props) => (
  <Box>
    <Text fontSize="xs" fontWeight="semibold" color="gray.500" textTransform="uppercase" mb={1}>
      {label}
    </Text>
    <Flex gap={2} alignItems="center">
      <Input isReadOnly size="sm" value={value} bg="gray.50" _readOnly={{ color: "gray.500" }} fontSize="sm" />
      <CopyToClipboard text={value} variant="outline" colorScheme="button.light" size="sm" borderRadius="full" flexShrink={0}>
        Copy
      </CopyToClipboard>
    </Flex>
    {helperText && (
      <Text fontSize="sm" color="gray.600" mt={1}>
        {helperText}
      </Text>
    )}
  </Box>
)

export default CopyableLink
